<template>
  <div id="track" class="container">
    <div v-visibility-change="visibilityChange">
      <NavBar class="t-navbar" :is-map="flags.isTracker" :delivery-code="order.deliveryCode" :show-code="flags.showDeliveryCode" :show-workspace-name="false" :is-cash="isCash" :cash-msg="cashBasic" />
      <div>
        <transition name="fade" mode="out-in">
          <div>
            <div v-if="!flags.isTracker && order.orderStep !== 'CANCELED'" :class="`image-basic1 ${order.customIndicators.topImage}`">
              <component :is="order.customIndicators.statusImage" />
            </div>
            <div v-else-if="order.orderStep === 'CANCELED'">
              <img :src="order.customIndicators.statusImage" :class="`image-basic1 ${order.customIndicators.topImage}`">
            </div>
            <div :class="flags.showTextAccepted ? 'basic1-container-accepted' : 'basic1-container-showTextOnsite'">
              <div v-if="flags.showTextAccepted">
                <div class="basic1-text-warning">{{ $t('general.attention') }}</div>
                <div class="basic1-text-pin mt-2 pl-18 pr-18">{{ $t('general.confirmDeliveryWithCode') }}</div>
                <div class="basic1-text-description-pin mt-5 pl-18 pr-19">
                  <ul class="mt-1">
                    <li>{{ $t('messages.assignDriverCode') }}</li>
                    <li>{{ $t('messages.waitUntilYouReceiveOrderToSharePin') }}</li>
                  </ul>
                </div>
              </div>
              <div v-else-if="flags.showTextOnsite" class="basic1-text-pin pl-18 pr-18">
                {{ $t('messages.shareYourPinWithDriver') }}
              </div>
            </div>
          </div>
        </transition>
        <el-row type="flex" justify="center">
          <transition name="fade" mode="out-in">
            <Map
              v-if="flags.isTracker"
              :key="map.componentKey"
              :driver="driver.coords"
              :branch="branch.coords"
              :delivery="delivery.coords"
              :disconnected-route-coordinates="disconnectedRouteCoordinates"
              :animation-disconnected="animationDisconnected" />
          </transition>
        </el-row>
        <div :class="`basic-one-delivery-man-track ${flags.showDetailDriver ? 'track-detail' : 'track-accepted'}`">
          <transition name="fade" mode="out-in">
            <delivery-man-detail
              v-if="!flags.loading"
              :total="order.totalAmount"
              :currency="order.currencyType"
              :folio="order.folio"
              :order="order"
              :estimated-time="estimatedTime"
              :wa-phone="order.whatsapp"
              :status-message="order.customIndicators.statusMessage"
              :show-detail-driver="flags.showDetailDriver"
              class="dm-s"
              @on-view-folio-status="onViewFolioStatus" />
          </transition>
        </div>
        <el-dialog
          id="status-dialog"
          :visible.sync="flags.isStatusDialog"
          close-on-press-escape
          :title="$t('general.folioStatus')"
          width="90%"
          center>
          <task-card-steps
            v-model="order"
            @close="onClose" />
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import TemplateMethods from '@/utils/mixins/templateMethods'
import DeliveryManDetail from '@/views/templates/basic1/component/deliveryDetail'

// svg
import InProcess from '@/assets/images/svg/templates/basic1/in_process.svg'
import DriverOnsite from '@/assets/images/svg/templates/basic1/driver_onsite.svg'
import Completed from '@/assets/images/svg/templates/basic1/completed.svg'

import { object, ACCEPTED_STATUS } from '@/utils/status'

export default {
  name: 'BasicTaskTrack',
  components: {
    DeliveryManDetail,
    InProcess,
    DriverOnsite,
    Completed
  },
  mixins: [TemplateMethods],
  data() {
    return {
      flags: {
        showDetailDriver: false,
        showTextAccepted: false,
        showTextOnsite: false,
        showDeliveryCode: false
      },
      cashBasic: 'cashBasic'
    }
  },
  methods: {
    determineStatus: function() {
      let isDisabledDetailButton = false
      let statusImage = 'InProcess'
      let statusLevel = 1
      let statusMessage = this.$t('stepDescriptions.inProcess')
      let onSiteAnimation = false
      let isETAAlerts = true
      this.flags.loading = true
      this.flags.showDetailDriver = false
      this.flags.showTextAccepted = false
      this.flags.showTextOnsite = false
      this.flags.showDeliveryCode = false
      this.flags.isTracker = false
      let topImage = 'default-top'
      switch (this.order.orderStep) {
        case ACCEPTED_STATUS.find(val => val === this.order.orderStep):
          statusImage = 'InProcess'
          statusMessage = this.$t('stepDescriptions.inProcess')
          this.flags.showDetailDriver = false
          statusLevel = 1
          if (this.order.deliveryCode) {
            topImage = 'custom-delivery-code'
            this.flags.showTextAccepted = true
            this.flags.showTextOnsite = false
          }
          break
        case object.TRANSIT:
          statusMessage = this.$t('stepDescriptions.transit')
          statusLevel = 2
          this.flags.showDetailDriver = true
          this.flags.showDeliveryCode = true
          this.onEnableTracker()
          break
        case object.COMPLETED_REQUEST:
        case object.ONSITE:
          statusImage = 'DriverOnsite'
          statusMessage = this.$t('stepDescriptions.driverOnsite')
          statusLevel = 3
          topImage = 'custom-top'
          onSiteAnimation = true
          this.flags.isTracker = false
          this.flags.showDetailDriver = true
          if (this.order.deliveryCode) {
            this.flags.showDeliveryCode = true
            this.flags.showTextAccepted = false
            this.flags.showTextOnsite = true
          }
          break
        case object.COMPLETED:
          statusImage = 'Completed'
          statusMessage = this.$t('stepDescriptions.completed')
          statusLevel = 4
          isETAAlerts = false
          topImage = 'custom-top'
          this.flags.showDetailDriver = true
          this.flags.showTextAccepted = false
          this.flags.showTextOnsite = false
          this.flags.showDeliveryCode = false
          break
        case object.CANCELED:
          statusImage = '/img/status/status_cancel.png'
          statusMessage = this.$t('steps.CANCELED.description')
          statusLevel = 4
          isETAAlerts = false
          isDisabledDetailButton = true
          this.flags.showDetailDriver = true
          topImage = 'custom-top'
          break
      }
      this.order.customIndicators = {
        statusImage,
        statusLevel,
        statusMessage,
        isETAAlerts,
        onSiteAnimation,
        isDisabledDetailButton,
        topImage
      }
      this.flags.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.t-navbar {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 3;
}
.t-address-bar {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -moz-box;
  display: flex;
  position: absolute;
  top: 20px;
  left: 20px;
  width: calc(100% - 40px);
  z-index: 3;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  border-radius: 8px;
  background-color: white;
  -webkit-box-shadow: 4px 4px 10px rgba(162, 162, 165, 0.7);
  -moz-box-shadow: 4px 4px 10px rgba(162, 162, 165, 0.7);
  -ms-box-shadow: 4px 4px 10px rgba(162, 162, 165, 0.7);
  -o-box-shadow: 4px 4px 10px rgba(162, 162, 165, 0.7);
  box-shadow: 4px 4px 10px rgba(162, 162, 165, 0.7);
  padding: 16px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-justify-content: flex-start;
  -moz-justify-content: flex-start;
  -ms-justify-content: flex-start;
  -o-justify-content: flex-start;
  justify-content: flex-start;
}

.t-address-container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -moz-box;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  margin-right: 8px;
  -webkit-align-self: flex-start;
  -moz-align-self: flex-start;
  -ms-align-self: flex-start;
  -o-align-self: flex-start;
  align-self: flex-start;
}

.t-address-container .el-icon-arrow-left {
  cursor: pointer;
  margin-right: 6px;
  margin-top: 2px;
}

.t-address-delivery {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1875px;
  color: #170B56;
}

span.t-address-value {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1875px;
  color: #170B56;
  opacity: 0.2;
  -webkit-text-transform: capitalize;
  -moz-text-transform: capitalize;
  -ms-text-transform: capitalize;
  -o-text-transform: capitalize;
  text-transform: capitalize;
}

.btn-center-path svg {
  width: 20px;
  height: 20px;
  color: white;
}

.basic-one-delivery-man-track {
  position: fixed;
  bottom: 0;
  max-width: 500px;
  width: 100%;
  overflow: hidden;
  background: #FBFBFB;
  z-index: 3;
  &.track-accepted {
    min-height: 25vh;
  }
  &.track-detail {
    min-height: 37vh;
  }
}

.marker-driver {
  border: none;
  cursor: pointer;
  height: 33.8px;
  width: 18px;
  background-image: url('/img/ic_marker_driver_red.png');
  background-color: rgba(0, 0, 0, 0);
  background-size: contain;
}

.marker-branch {
  border: none;
  cursor: pointer;
  height: 40px;
  width: 44px;
  background-image: url('/img/ic_marker_branch_2d.png');
  background-color: rgba(0, 0, 0, 0);
  background-size: contain;
}

.marker-delivery {
  border: none;
  cursor: pointer;
  height: 41px;
  width: 36px;
  background-image: url('/img/svg/meta-marker.svg');
  background-color: rgba(0, 0, 0, 0);
  background-size: contain;
}

.marker-driver-x {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 4px solid white;
  box-shadow: 0px 3px 30px #CAD1D8;
  background: #efefef;
}

.btn-track {
  position: absolute !important;
  bottom: 46vh !important;
  right: 16px !important;
  height: 40px !important;
  width: 40px !important;
}

.basic1-container-accepted {
  position: absolute;
  bottom: 28%;
  z-index: 2;
}

.basic1-container-showTextOnsite {
  position: absolute;
  bottom: 46%;
  z-index: 2;
}

@media (height: 667px) {
  .basic1-container-accepted {
    position: absolute;
    bottom: 23%;
    z-index: 2;
  }
}
</style>
